import { type HTMLAttributes } from "react";
import { cn } from "@/shared/lib/cn";

export function Card({ className, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        "bg-white rounded-lg border border-ink-12 p-6 transition-shadow hover:shadow-sm",
        className,
      )}
      {...rest}
    />
  );
}
